import { SharedModule } from 'src/app/shared/shared.module'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import * as fromRental from '../rental/rental.reducer'
import { RentalRoutingModule } from './rental-routing.module'
import { RentalEffects } from './rental.effects'
import { RentalSerializer } from './rental.serializer'
import { RentalService } from './rental.service'
import { ProductModule } from '../product/product.module'

@NgModule({
  imports: [
    RentalRoutingModule,
    SharedModule,
    StoreModule.forFeature(fromRental.FEATURE_NAME, fromRental.rentalReducer),
    EffectsModule.forFeature([RentalEffects]),
    ProductModule
  ],
  declarations: [],
  exports: [],
  providers: [
    RentalService,
    {
      provide: RentalSerializer,
      useClass: RentalSerializer
    }
  ]
})
export class RentalModule {}
